module.exports = __webpack_public_path__ + "media/59.d6597e0b.mp3";